export default "__VITE_ASSET__3ec34a83__"